const state = {
  loadingCount: 0,
  isSearchOpen: false,
}

const mutations = {
  setLoading (state, newState) {
    if (newState) {
      state.loadingCount++
    } else {
      state.loadingCount--
    }
  },

  setSearchVisibility (state, status) {
    state.isSearchOpen = status
  }
}

const actions = {
}

const getters = {
  isLoading (state) {
    return !!state.loadingCount
  },

  isSearchOpen ({ isSearchOpen }) {
    return isSearchOpen
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
